var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H15.5V10H0.5V0ZM8 2.5C8.66304 2.5 9.29893 2.76339 9.76777 3.23223C10.2366 3.70107 10.5 4.33696 10.5 5C10.5 5.66304 10.2366 6.29893 9.76777 6.76777C9.29893 7.23661 8.66304 7.5 8 7.5C7.33696 7.5 6.70107 7.23661 6.23223 6.76777C5.76339 6.29893 5.5 5.66304 5.5 5C5.5 4.33696 5.76339 3.70107 6.23223 3.23223C6.70107 2.76339 7.33696 2.5 8 2.5ZM3.83333 1.66667C3.83333 2.10869 3.65774 2.53262 3.34518 2.84518C3.03262 3.15774 2.60869 3.33333 2.16667 3.33333V6.66667C2.60869 6.66667 3.03262 6.84226 3.34518 7.15482C3.65774 7.46738 3.83333 7.89131 3.83333 8.33333H12.1667C12.1667 7.89131 12.3423 7.46738 12.6548 7.15482C12.9674 6.84226 13.3913 6.66667 13.8333 6.66667V3.33333C13.3913 3.33333 12.9674 3.15774 12.6548 2.84518C12.3423 2.53262 12.1667 2.10869 12.1667 1.66667H3.83333Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.1e1f2bc6e1ad5eb5b25c234bdbb9376d.svg";
export { ForwardRef as ReactComponent };